import { shopScene } from '../shopkit.js';

/** 书局：卖书也租书，最贵的那几本锁在玻璃柜里。 */
export const libraryDoc = shopScene({
  id: 'library',
  name: '书局',
  shop: 'library',
  owner: '书局掌柜',
  desc: '一屋子书，最贵的那几本锁在玻璃柜里。',
  w: 22, h: 18,
  counters: [{ gx: 8, gy: 3, len: 5, kind: 'library' }],
  props: [
    { type: 'bookcase', gx: 3, gy: 6 },
    { type: 'locked_glass_bookcase', gx: 16, gy: 6 },
    { type: 'desk', gx: 9, gy: 10 },
    { type: 'stool', gx: 10, gy: 11 },
    { type: 'notice_board', gx: 18, gy: 12 },
  ],
  portals: [
    { to: 'main_street', gx: 11, gy: 17, spawn: [19, 9], label: '回主街' },
  ],
});

export default libraryDoc;
